import axios from 'axios';
import { constant } from '@app/utils/constant';
import Cookies from 'js-cookie';

export const getAuditLog = async (filter: any) => { 
  const BearerToken = Cookies.get(constant.Cookie_Name);
  let params = '?per_page=5000';
  let restype = 'json';

  if (filter.from) {
    params += '&from_date=' + filter.from;
  }
  if (filter.to) {
    params += '&to_date=' + filter.to;
  }
  if (filter.portal_id) {
    params += '&portal_id=' + filter.portal_id;
  }
  if (filter.user_id) {
    params += '&user_id=' + filter.user_id;
  }
  try {
    const response = await axios.get(constant.API_BASEPATH + '/audit-log' + params, { headers: { "Authorization": `Bearer ${BearerToken}` }, responseType: restype });
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const getAuditLogById = async (id: number) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.get(constant.API_BASEPATH + '/audit-log/' + id, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
}; 